<template>
    <UiModal ref="modal" v-model:display="display" :title="title" :container-class="containerClass" static @key="onModalKey">
        <p>{{ message }}</p>
        <template #footer>
            <UiButton variant="secondary" @click="close">{{ t("Cancel") }}</UiButton>
            <UiButton :variant="danger ? 'danger' : 'primary'" icon="fas fa-check" @click="confirm">{{ t("Confirm") }}</UiButton>
        </template>
    </UiModal>
</template>

<script setup lang="ts">
import { useTemplateRef } from "vue";
import { useModalClose } from "@/composables/useModal";
import UiModal from "@/components/utils/UiModal.vue";
import UiButton from "@/components/utils/UiButton.vue";
import { handleModalConfirmKey } from "@/utils/form-keyboard";

defineOptions({ name: "ConfirmationModal" });

const display = defineModel<boolean>("display");

const {
    title = "",
    message = "",
    danger = false,
    containerClass = "",
} = defineProps<{
    title?: string;
    message?: string;
    danger?: boolean;
    containerClass?: string;
}>();

const emit = defineEmits<{
    confirm: [];
}>();

const modal = useTemplateRef("modal");
const close = useModalClose(modal);

const confirm = () => {
    close();
    emit("confirm");
};

const onModalKey = (e: KeyboardEvent) => {
    handleModalConfirmKey(e, confirm);
};
</script>
